import "./ProfileGenderInfo.scss";
import React from "react";
import _ from "lodash";
import { config } from "../../../../../config";
import { getGenderLabel } from "../../../../../libs/helper";
import { GENDER } from "../../../../../const/user";

const COLOR_NEUTRAL = "#666666";
const COLOR_MALE = "#0c75ed";
const COLOR_MALE_DARKEN = "#4141bd";
const COLOR_FEMALE = "#f04f7d";
const COLOR_FEMALE_DARKEN = "#fe2525";

const COLOR_NON_BINARY = "#f9e79f";
const COLOR_NON_BINARY_DARKEN = "#d68910";

const ORIENTATION_MAP = {
  "Non renseigné": null,
  'Hétéro': null,
  'Bisexuelle': 'Bi'
};

const ProfileGenderInfo = ({ user }) => {
  let colorsSex = [];

  const gendersInfo = (_.get(user, "profile.informations") || []).map(
    (userInfo) => {
      const orientation = config.genderOrientation[userInfo.orientation];
      if(user?.profile?.gender === GENDER.NON_BINARY){
        colorsSex.push(COLOR_NON_BINARY);
      }
      else if(user?.profile?.gender === GENDER.WOMAN){
        colorsSex.push(COLOR_FEMALE);
      }
      else if(user?.profile?.gender === GENDER.MAN){
        colorsSex.push(COLOR_MALE);
      }
      else{
        colorsSex.push(userInfo.sex === 1 ? COLOR_FEMALE : COLOR_MALE);
      }

      return {
        orientation: ORIENTATION_MAP[orientation] !== undefined ? ORIENTATION_MAP[orientation] : orientation,
        // Tranche calculée par l'API, qui ne renvoie plus la date de naissance des autres membres.
        ageRange: userInfo.ageRange || null,
      };
    }
  );

  if (colorsSex.length === 1) {
    const colorSex = colorsSex[0];
    if(user?.profile?.gender === 6){
        colorsSex.push("#f1c40f");
        colorsSex.push(COLOR_NON_BINARY_DARKEN);
    }
    else if (colorSex === COLOR_MALE) colorsSex.push(COLOR_MALE_DARKEN);
    else if (colorSex === COLOR_FEMALE) colorsSex.push(COLOR_FEMALE_DARKEN);
  }

  const gradientStyle = {
    backgroundColor: COLOR_NEUTRAL,
    background: `linear-gradient(45deg, ${colorsSex.join(",")})`,
  };

  return (
    <div className="profile-gender-info" style={gradientStyle}>
      <span className="profile-gender-info-label">
        {getGenderLabel(user.profile.gender)}
      </span>
      <span>
        {gendersInfo.map((genderInfo, i) => genderInfo.ageRange ? (
          <div key={i} className={"profile-gender-info-item"}>
            {genderInfo.ageRange}
            {!user?.setting?.notDisplayOrientationInProfile &&
              genderInfo.orientation
              ? ` ${genderInfo.orientation}`
              : ""}
          </div>
        ) : null)}
      </span>
    </div>
  );
};

export default ProfileGenderInfo;
